import script from "./RequestSent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestSent.vue?vue&type=script&setup=true&lang=ts"

import "./RequestSent.vue?vue&type=style&index=0&id=a787168e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a787168e"]])

export default __exports__